import { render, staticRenderFns } from "./batchImportRecord-list.vue?vue&type=template&id=338b4493&scoped=true&"
import script from "./batchImportRecord-list.vue?vue&type=script&lang=js&"
export * from "./batchImportRecord-list.vue?vue&type=script&lang=js&"
import style0 from "./batchImportRecord-list.vue?vue&type=style&index=0&id=338b4493&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338b4493",
  null
  
)

export default component.exports